const getTotalRawParts = (store) => {
  return store.totalRawParts;
};

export { getTotalRawParts };
